









import { NextQuery } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';

@Component
export default class NextQuerySuggestion extends Vue {
  @Prop({ required: true })
  suggestion: NextQuery;

  @Prop()
  selected: boolean;

  @Prop({ default: EVENTS.NextQuerySuggestionSelected })
  event: string;

  selectSuggestion() {
    this.$x.emit(this.event, this.suggestion);
  }
}
